import { createVanIconComponent } from "./van"

const MusicOutlined = createVanIconComponent("music-o")
export default MusicOutlined
